<template>
    <card class="card-plain waveline-container" v-loading="prefetching">
        <router-view>
        </router-view>
    </card>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import wavelineStore from '@/store/modules/user/waveline'

  export default {
    name: 'WavelineContainer',
    beforeCreate () {
      this.$store.registerModule('user/waveline'.split('/'), wavelineStore)
    },

    beforeDestroy () {
      this.$store.unregisterModule('user/waveline'.split('/'))
    },

    mounted () {
      if (this.$route.name === 'WavelineContainer') {
        this.init()
      }
    },

    computed: {
      ...mapState('user/waveline', {
        prefetched: state => state.prefetched,
        prefetching: state => state.prefetching,
        directUser: state => state.directUser,
        directTeam: state => state.directTeam,
        directQuestionnaire: state => state.directQuestionnaire
      })
    },

    methods: {
      ...mapActions('user/waveline', { prefetch: 'prefetch' }),
      async init () {
        if (this.prefetched) {
          this._handlePrefetchedChange()
        } else {
          this.prefetch()
        }
      },
      _handlePrefetchedChange: function () {
        if (this.prefetched) {
          if (this.directUser && this.directUser._id) {
            this.$router.push({ name: 'WavelineUserView', params: { qid: this.directQuestionnaire._id, tid: this.directTeam._id, uid: this.directUser._id } })
          } else if (this.directTeam && this.directTeam._id) {
            this.$router.push({ name: 'WavelineUserSelection', params: { qid: this.directQuestionnaire._id, tid: this.directTeam._id } })
          } else if (this.directQuestionnaire && this.directQuestionnaire._id) {
            this.$router.push({ name: 'WavelineTeamSelection', params: { qid: this.directQuestionnaire._id } })
          } else {
            this.$router.push({ name: 'WavelineQuestionnaireSelection' })
          }
        }
      }
    },

    watch: {
      prefetched () {
        this._handlePrefetchedChange()
      },
      '$route' () {
        if (this.$route.name === 'WavelineContainer') {
          this.init()
        }
      }
    }
  }
</script>

<style lang="scss">
    .waveline-container {
        .card-body {
            padding-top: 0 !important;
        }
    }
</style>